const os = {
    name: '',
    version: '',
};

const { userAgent } = window.navigator;

if (userAgent.indexOf('Windows') !== -1) {

    os.name = 'Windows';

    if (userAgent.indexOf('Windows NT 5.1') !== -1) {

        os.version = 'XP';

    } else if (userAgent.indexOf('Windows NT 6.1') !== -1) {

        os.version = '7';

    } else if (userAgent.indexOf('Windows NT 6.0') !== -1) {

        os.version = 'Vista';

    } else if (userAgent.indexOf('Windows NT 6.2') !== -1) {

        os.version = '8';

    } else if (userAgent.indexOf('Windows NT 5.0') !== -1) {

        os.version = '2000';

    }

} else if (userAgent.indexOf('Mac') !== -1) {

    os.name = 'Mac/iOS';

} else if (userAgent.indexOf('Linux') !== -1) {

    os.name = 'Linux';

} else if (userAgent.indexOf('X11') !== -1) {

    os.name = 'UNIX';

} else if (userAgent.indexOf('sunos') !== -1) {

    os.name = 'Solaris';

} else {

    os.name = userAgent.replace(/_/g, '.');

}

os.fullVersion = `${os.name} ${os.version}`;


const OSBrowserDetection = {
    OS: os.name,
    OSVersion: os.fullVersion,
    getOSVersion: () => os.fullVersion,
};


export default OSBrowserDetection;



// WEBPACK FOOTER //
// ./scripts/common/services/util/-RFC.OSBrowserDetection.js